import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { MdDelete, MdUpload } from "react-icons/md";
import { update_suspect } from "../../../services/api-service";
import AutoFaceIdCamera from "../../add-student-details/AutoFaceIdCamera";
import "../../add-student-details/AddStudents.css";
import "../../add-student-details/StudentRegistration.css";

const EditSuspect = () => {
  const location = useLocation();
  const history = useHistory();
  
  // Get the suspect data passed from the SuspectList page
  const passedSuspect = location.state?.suspect || {};

  const [suspect_id, setSuspectId] = useState(passedSuspect.suspect_id || "");
  const [full_name, setFullName] = useState(passedSuspect.full_name || "");
  const [email, setEmailId] = useState(passedSuspect.email || "");
  const [mobile_no, setMobileNumber] = useState(passedSuspect.mobile_no || "");
  
  const [loading, setLoading] = useState(false);

  // Camera/Image States (Kept for layout consistency and future updates)
  const [images, setImages] = useState(passedSuspect.image || null);
  const [allImages, setAllImages] = useState([]);
  const [hidePreview, setHidePreview] = useState(false);

  // Fallback if accessed directly without data
  useEffect(() => {
    if (!passedSuspect.suspect_id) {
      toast.error("No suspect data found. Redirecting...");
      history.push("/admin/suspect-list");
    }
  }, [passedSuspect, history]);

  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
    if (!hidePreview) setHidePreview(true);
  };

  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
    if (!hidePreview) setHidePreview(true);
  };

  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleSubmit = async () => {
    setLoading(true);
    toast.info("Updating suspect, please wait...");

    const payload = {
      full_name,
      email,
      mobile_no
    };

    try {
      const response = await update_suspect(suspect_id, payload);
      if (response.status === 200) {
        toast.success("Suspect Updated Successfully!");
        history.push("/admin/suspect-list"); // Go back to the directory
      }
    } catch (error) {
      console.error("Error updating suspect:", error);
      toast.error(error.response?.data?.detail || "Failed to update suspect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="container mt-4">
        
        {/* --- LEFT COLUMN: FORM FIELDS --- */}
        <div className="form-section">
          <h2>Edit Suspect Details</h2>

          <div className="form-group w-100 mb-3">
            <label className="lebcs">Suspect ID</label>
            <input 
              className="Asss" 
              type="text" 
              value={suspect_id} 
              disabled 
              style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
            />
          </div>

          <div className="form-row">
            <div className="form-group w-100">
              <label className="lebcs">Full Name</label>
              <input 
                className="Asss" 
                type="text" 
                placeholder="Unknown" 
                value={full_name} 
                onChange={(e) => setFullName(e.target.value)} 
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Email</label>
              <input 
                className="Asss" 
                type="email" 
                placeholder="Email Address" 
                value={email} 
                onChange={(e) => setEmailId(e.target.value)} 
              />
            </div>

            <div className="form-group">
              <label className="lebcs">Contact Number</label>
              <input 
                className="Asss" 
                type="tel" 
                placeholder="Contact Number" 
                value={mobile_no} 
                onChange={(e) => setMobileNumber(e.target.value)} 
              />
            </div>
          </div>

          {/* UPDATE BUTTON ON THE LEFT */}
          <div style={{ marginTop: '30px' }}>
            <button 
              className="upload-btn" 
              onClick={handleSubmit} 
              disabled={loading} 
              style={{ width: '100%', padding: '12px', fontSize: '16px', backgroundColor: '#dc3545' }}
            >
              {loading ? "Updating..." : "Update Suspect"}
            </button>
          </div>
        </div>

        {/* --- RIGHT COLUMN: CAMERA AND GALLERY SECTION --- */}
        <div className="camera-section">
          <h2>Live Camera</h2>
          
          {/* Base64 Preview for already existing photo */}
          {!hidePreview && images && (
            <div style={{ textAlign: "center", marginBottom: "15px" }}>
              <img
                src={`data:image/png;base64,${images}`}
                alt="Current Saved Face"
                style={{ width: "150px", border: "2px solid #dc3545", borderRadius: "50%", objectFit: "cover", height: "150px" }}
              />
              <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>Current Primary Photo</p>
            </div>
          )}

          <AutoFaceIdCamera onImageCapture={handleImageCapture} />

          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            <label style={{ 
                color: '#fff', 
                backgroundColor: '#dc3545',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(220, 53, 69, 0.3)',
                marginBottom: '15px'
              }} 
              htmlFor="suspect_images"
            >
              Upload New Image(s)
              <MdUpload size={20} />
              <input className="Asss" id="suspect_images" accept=".png, .jpeg, .jpg" style={{ display: "none" }} type="file" multiple onChange={handleMultipleImageChange} />
            </label>

            {/* Visual Gallery with Delete Buttons */}
            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img src={imgSrc} alt={`captured-face-${index}`} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px", border: "2px solid #dc3545" }} />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute", top: "-6px", right: "-6px", background: "#ff4444", color: "white", border: "none",
                          borderRadius: "50%", width: "22px", height: "22px", cursor: "pointer", display: "flex", alignItems: "center",
                          justifyContent: "center", fontSize: "12px", boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSuspect;
